import * as React from "react";
import { cn } from "../../../lib/utils";
import { Card } from "../card";
import { Button } from "../button";

function EmptyState({ message, actionLabel, onAction, className, children }) {
  return (
    <Card
      variant="panel"
      className={cn(
        "flex flex-col items-center justify-center gap-3 py-10 text-center",
        className,
      )}
    >
      {message && <p className="text-muted-foreground">{message}</p>}
      {children}
      {actionLabel && onAction && (
        <Button variant="add" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Card>
  );
}

export { EmptyState };
